import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPencil, faBoxArchive, faFileImage, faMap } from '@fortawesome/free-solid-svg-icons';
import { UseCloudAdminFunction } from '../../../utils/firebase.utils';
import './evidence-list.styles.scss';
import { getQueryFromFirestore } from '../../../utils/getDataFromDbSimplified';

const EvidenceList = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [archiving, setArchiving] = useState(null);
  let templatesListener;
  const templatesRef = useRef({});

  const fetchTemplates = async () => {
    setLoading(true);
    templatesRef.current = {};
    getQueryFromFirestore({
      'path': 'evidenceTemplates',
      'queryArray': [
        { field: 'status', operator: '==', value: 'active' }
      ],
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      console.log(data);
      templatesRef.current[data.id] = data;
      setTemplates(Object.values(templatesRef.current).sort((a, b) => a.name.localeCompare(b.name)));
    }
    function handleListener(unsub) {
      templatesListener = unsub;
    }
    setLoading(false);
  };

  useEffect(() => { 
    fetchTemplates();
    
    return () => {
      if (templatesListener) templatesListener();
    }
  }, []);

  const handleEdit = (template) => {
    navigate('/admin/evidencecreator/editor', { state: { template } });
  };

  const handleArchive = async (templateId) => {
    setArchiving(templateId);
    const res = await UseCloudAdminFunction('archiveEvidenceTemplate', { templateId });
    if (res?.success) {
      setTemplates((prev) => prev.filter((t) => t.id !== templateId));
    }
    setArchiving(null);
  };

  const formatDate = (ts) => {
    if (!ts) return '—';
    const d = ts._seconds ? new Date(ts._seconds * 1000) : new Date(ts);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="el-root g-card">
      <div className="el-header">
        <h2 className="el-title">Evidence Templates</h2>
        <div className="el-header-actions">
          <button
            className="el-btn el-btn-outline"
            onClick={() => navigate('/admin/evidencecreator/statemap')}
          >
            <FontAwesomeIcon icon={faMap} /> State Assignments
          </button>
          <button
            className="el-btn el-btn-primary"
            onClick={() => navigate('/admin/evidencecreator/editor')}
          >
            <FontAwesomeIcon icon={faPlus} /> New Template
          </button>
        </div>
      </div>

      {loading ? (
        <div className="el-loading">Loading templates…</div>
      ) : templates.length === 0 ? (
        <div className="el-empty">
          <FontAwesomeIcon icon={faFileImage} />
          <p>No templates yet. Create your first one!</p>
        </div>
      ) : (
        <div className="el-grid">
          {templates.map((t) => (
            <div key={t.id} className="el-card">
              <div className="el-card-preview">
                {t.pages?.[0]?.bgImage
                  ? <img src={t.pages[0].bgImage} alt="" className="el-card-img" />
                  : <div className="el-card-placeholder"><FontAwesomeIcon icon={faFileImage} /></div>
                }
              </div>
              <div className="el-card-body">
                <div className="el-card-name">{t.name}</div>
                <div className="el-card-meta">
                  <span>{t.orientation === 'landscape' ? 'Landscape' : 'Portrait'}</span>
                  <span>
                    {t.pages?.length ?? 1} page{(t.pages?.length ?? 1) !== 1 ? 's' : ''}
                  </span>
                  <span>Updated {formatDate(t.updatedAt)}</span>
                </div>
                <div className="el-card-actions">
                  <button className="el-btn el-btn-outline" onClick={() => handleEdit(t)}>
                    <FontAwesomeIcon icon={faPencil} /> Edit
                  </button>
                  <button
                    className="el-btn el-btn-archive"
                    disabled={archiving === t.id}
                    onClick={() => handleArchive(t.id)}
                  >
                    <FontAwesomeIcon icon={faBoxArchive} />
                    {archiving === t.id ? ' Archiving…' : ' Archive'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EvidenceList;
